import VanguardConfig from '../../../config/vanguard';
import GlobalConfig from '../../../config/global-config';
import axios from 'axios';

/**
 * PalyanceV2 API
 */
export default class PalyanceV2Api {
  constructor() {
    this.baseHost = VanguardConfig.palyanceApiUrl;
    this.globalConfig = GlobalConfig;
  }

  getOgoneStatus(authorizationId, orderId = undefined) {
    return new Promise((resolve, reject) => {
      try {
        const param = orderId ? `orderId=${encodeURIComponent(orderId)}` : `authorizationId=${encodeURIComponent(authorizationId)}`;
        const url = `${this.baseHost}/ogone/waiting?${param}`;

        axios.get(url).then(({data}) => {
          if (!data || !data.status) {
            return reject(data);
          }

          resolve(data);
        }, error => {
          reject(error);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Get palyance eligibility
   * @returns {Promise}
   */
  getEligibility(walletIdentifier, paymentType, merchantIdentifier) {
    return new Promise((resolve, reject) => {
      try {
        const url = `${this.baseHost}/eligibility/aspsp?walletIdentifier=${encodeURIComponent(walletIdentifier)}&paymentType=${encodeURIComponent(paymentType)}&merchantIdentifier=${encodeURIComponent(merchantIdentifier)}`;

        axios.get(url).then(({data}) => {
          if (!data) {
            throw new Error('No data returned from palyance');
          }

          resolve(data);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Send token to palyance
   * @returns {Promise}
   */
  postToken(orderId, token) {
    return new Promise((resolve, reject) => {
      try {
        const url = `${this.baseHost}/aspsp/double-optin-code`;

        axios.post(url, {
          orderId,
          digitConfirmation: token,
          signedAt: Date.now()
        }).then(({data}) => {
          if (!data) {
            throw new Error('No data returned from palyance');
          }

          resolve(data);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Check if a client based on his orderId had validated the double optin
   * @param {string} orderId Order ID generated by Vanguard
   */
  hasClientValidatedDoubleOptin(orderId) {
    return new Promise((resolve, reject) => {
      try {
        const url = `${this.baseHost}/aspsp/double-optin?orderId=${encodeURIComponent(orderId)}`;

        axios.get(url).then(({data}) => {
          if (!data) {
            throw new Error('No data returned from palyance');
          }

          resolve(data);
        });
      } catch (error) {
        reject(error);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/api/palyance-v2-api.js